<script>
import NavigationOrder from "@/components/ordering/NavigationOrder.vue";
import PaymentPanel from "@/components/ordering/panels/PaymentPanel.vue";
import DeliveryPanel from "@/components/ordering/panels/DeliveryPanel.vue";
import OrderPrice from "@/components/ordering/panels/OrderPrice.vue"
import {mapStores} from "pinia";
import {useAuthStore} from "@/stores/auth";
import {api} from "@/modules/api";
import {cart} from "@/modules/cart";
import LoadingPayment from "@/components/ordering/LoadingPayment.vue";

export default {
  name: 'CheckoutInfo',
  computed: {
    ...mapStores(useAuthStore)
  },
  components: {LoadingPayment, OrderPrice, DeliveryPanel, PaymentPanel, NavigationOrder},
  data () {
    return {
      deliveryAddress: null,
      loading: false
    }
  },
  mounted () {
    this.emitter.on('delivery-address', (id) => {
      this.deliveryAddress = id
    })
    this.emitter.on('submit-order', (id) => {
      this.loading = true
      setTimeout(() => {
        api.cart.validate({deliveryAddress: id}).then(res => {
          cart.getCart()
          this.$router.push({name: 'app_order_success', params: {id: res.id}})
          this.loading = false
        })
      }, 2000);
    })
  }
}
</script>

<template>
  <section class="bg-white py-8 antialiased dark:bg-gray-900 md:py-16">
    <loading-payment v-if="loading" />
    <div class="mx-auto max-w-screen-xl px-4 2xl:px-0">
      <navigation-order />
      <div class="mt-6 sm:mt-8 lg:flex lg:items-start lg:gap-12 xl:gap-16">
        <div class="min-w-0 flex-1 space-y-8">
          <router-view :delivery-address="deliveryAddress" />
          <payment-panel v-if="$route.name === 'order_checkout'" />
          <delivery-panel v-if="$route.name === 'order_checkout'" />
        </div>
        <order-price :products-cart="authStore.getCart.productsCart" :delivery-address="deliveryAddress" />
      </div>
    </div>
  </section>
</template>
